module.exports = __webpack_public_path__ + "static/media/rifa_duke.5d701059.png";